/**
 * ClerkBridge — wires Clerk's session token into the api.ts module.
 *
 * api.ts is a plain module (not a React hook), so it cannot call useSession()
 * directly. This component sits at the root of the app tree, inside
 * ClerkProvider, and registers a token getter whenever the Clerk session
 * changes.
 *
 * `session.getToken()` always returns a fresh short-lived JWT — Clerk
 * refreshes the underlying session transparently, so no manual refresh logic
 * is needed in the app.
 *
 * Renders nothing — it is a side-effect-only component.
 */
import { useEffect } from 'react';
import { useSession } from '@clerk/clerk-react';
import { setClerkTokenGetter } from '../lib/api';
export function ClerkBridge() {
    const { session } = useSession();
    useEffect(() => {
        if (session) {
            setClerkTokenGetter(() => session.getToken());
        }
        else {
            setClerkTokenGetter(() => Promise.resolve(null));
        }
    }, [session]);
    return null;
}
